import { render, staticRenderFns } from "./async_data_channel.vue?vue&type=template&id=0b48645d&scoped=true"
import script from "./async_data_channel.vue?vue&type=script&lang=js"
export * from "./async_data_channel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b48645d",
  null
  
)

export default component.exports